import tippy from 'tippy.js/dist/tippy-bundle.umd.min.js'; // JS + CSS
import 'tippy.js/themes/light-border.css';

export default tippy;